export default {
    state: {
        selectedTint: null,
        selectedFrame: null,
        isGifModalOpened: false,
        wordings: [
            {
                id: '1',
                word: 'Rubis'
            },
            {
                id: '2',
                word: 'Améthyste'
            },
            {
                id: '3',
                word: 'Ambre'
            },
            {
                id: '4',
                word: 'Emeraude'
            },
            {
                id: '5',
                word: 'Gris'
            },
            {
                id: '6',
                word: 'Brun'
            },
            {
                id: '7',
                word: 'Saphir'
            },
            {
                id: '8',
                word: 'Graphite Green'
            },
            {
                id: 'A',
                word: 'Vert'
            },
            {
                id: 'B',
                word: 'Marron'
            },
            {
                id: 'C',
                word: 'Bleu foncé'
            },
            {
                id: 'D',
                word: 'Bleu clair'
            },
            {
                id: 'E',
                word: 'Jaune'
            },
            {
                id: 'F',
                word: 'Orange'
            },
            {
                id: 'G',
                word: 'Rouge'
            },
            {
                id: 'H',
                word: 'Violet'
            },
        ]
    },
    actions: {
        updatePropColorTint({ commit }, data) {
            commit('setPropColorTint', data);
        },
        updatePropColorFrame({ commit }, data) {
            commit('setPropColorFrame', data);
        }
    },
    mutations: {
        setPropColorTint(state, data) {
            state.selectedTint = data;
        },
        setPropColorFrame(state, data) {
            state.selectedFrame = data;
        }
    },
    getters: {
        getPropColorTint: state => {
            return state.selectedTint;
        },
        getPropColorFrame: state => {
            return state.selectedFrame;
        },
        getWordingWithTag: state => (tag) => {
            const ids = tag.split('');
            const currentWording = [];
            state.wordings.forEach(wording => {
                ids.forEach(id => {
                    if (id == wording.id) {
                        currentWording.push(wording.word);
                    }
                });
            });
            return currentWording;
        }
    },
};